<!--suppress TypeScriptUnresolvedFunction -->
<script lang="ts">
    import { onDestroy } from 'svelte'
    import { link } from 'svelte-spa-router'
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'
    import { getIdFromSlug } from '../../../core/helpers/url.helper'
    import type { IService } from '../interfaces/service.interface'
    import { slugify } from '../../../core/helpers/string.helper'
    import type { ICategory, ISubCategory } from '../interfaces/category.interface'
    import { scrollToTop } from '../../../core/helpers/window.helper'
    import AppError from './Error.svelte'

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider
    export let params: { subCategoryId: string } | null

    let processingMainServices: boolean = false;
    let errorMainServices: boolean = false;
    let mainServices: IService[] = []

    let category: ICategory = null
    let subCategory: ISubCategory = null

    $: subCategoryId = getIdFromSlug(params.subCategoryId)
    $: dataProvider.selectedSubCategoryId = String(subCategoryId)
    $: serviceProvider.serviceService.loadMainServices(String(subCategoryId))
    $: serviceProvider.categoryService.prepareSubCategoryById(subCategoryId)

    onDestroy(() => {
        dataProvider.selectedSubCategoryId = null
        serviceProvider.serviceService.resetMainServices()
    })

    // SERVICES

    serviceProvider.serviceService.processingMainServicesSubs.subscribe((status) => (processingMainServices = status))
    serviceProvider.serviceService.errorMainServicesSubs.subscribe((status) => (errorMainServices = status))
    serviceProvider.serviceService.mainServicesSubs.subscribe((data) => {
        mainServices = data
        // @ts-ignore
        setTimeout(() => removeClickFocus(), 100)
        scrollToTop()
    })

    serviceProvider.categoryService.categorySubs.subscribe((data) => category = data)
    serviceProvider.categoryService.subCategorySubs.subscribe((data) => subCategory = data)
</script>

<div class="bno-category-list__col bno-category-list__tasks">
    <div class="bno-category-list__col-inner is-active">
        <div class="bno-category-list__content">
            <h2>
                {#if category}
                    <a href="/{category.id}-{slugify(category.nazev)}"
                       use:link
                       class="bno-category-list__back-btn"
                       aria-label="Vrátit se zpět"
                       role="button"
                       tabindex="0"/>
                {/if}
                {#if subCategory}
                    {subCategory.nazev}
                {/if}
            </h2>
        </div>
        {#if processingMainServices}
            <!-- <div class="bno-category-list__content">
                <p>Načítám...</p>
            </div> -->
        {:else if errorMainServices}
            <div class="bno-category-list__content">
                <AppError />
            </div>
        {:else}
            <ul class="bno-category-list__nav">
                {#each mainServices as service}
                    <li class="bno-category-list__nav-item">
                        <a
                            href="{service.slug}"
                            title="{service.nazev}"
                            aria-label="{category.nazev}"
                            class="bno-category-list__nav-link">
                            <h4>
                                <span class="bno-link">{service.nazev}</span>
                            </h4>
                        </a>
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
</div>
